import api from "./axios";

export const getPublicSettings = () => api.get("/api/settings/");
export const adminGetSettings = () => api.get("/api/admin/settings/");
export const adminUpdateSetting = (key, data) => api.put(`/api/admin/settings/${key}/`, data);
export const adminCreateSetting = (data) => api.post("/api/admin/settings/", data);